import React, { useState, useEffect, createContext, useContext } from 'react';
import axios from 'axios';
import { useApp } from './app-context';
import { v4 as uuidv4 } from 'uuid';
import { useLocation } from 'react-router-dom';
import { get } from 'lodash';

type AemAppData = {
  isLoading?: boolean;
  user?: any;
  isUserAuthenticated?: boolean;
  checkUserHasActiveSession?: () => boolean | undefined;
  doStepUpAuthentication?: () => void;
};

type User = {
  authToken: string;
};
export const AuthContext = createContext<AemAppData>({});
function _window() {
  return window;
}

const AuthProvider = ({ children }) => {
  const { appData } = useApp();
  const [user, setUser] = useState();
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const deleteCookie = (name) => (document.cookie = `${name}=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/`);
  const setCookie = (name, value) => (document.cookie = `${name}=${value}; path=/`);
  const location = useLocation();

  useEffect(() => {
    if (appData.platform === 'web') {
      getUserInfo();
    }
  }, []);

  useEffect(() => {
    if (!user) return;
    if (!checkUserHasActiveSession()) return;
  }, [location]);

  const getSSORoute = () => {
    let sso_url;
    if (user && user['userType'] === 'G') {
      sso_url = appData.environmentVariables.SIGN_IN_URL;
    } else if (user && user['userType'] === 'R') {
      sso_url = appData.environmentVariables.RE_SIGN_IN_URL;
    } else {
      //if user is KMSI user send to Re-Sign-in else send to Sign-in
      if (
        _window()['AB'] &&
        _window()['AB']['COMMON'] &&
        _window()['AB']['COMMON'].getCookie('SAFEWAY_KMSI') === true
      ) {
        sso_url = appData.environmentVariables.RE_SIGN_IN_URL;
      } else {
        sso_url = appData.environmentVariables.SIGN_IN_URL;
      }
    }
    return sso_url;
  };

  const redirectToSSO = () => {

    let sso_url = getSSORoute();
    const cookieName = appData.isBusinessBanner ? 'ACI_S_B_ECommRedirectURL' : 'ACI_S_ECommRedirectURL';
    setCookie(cookieName, encodeURIComponent(window.location.href));
    window.location.assign(sso_url);
  };

  useEffect(() => {
    if (!user) return;
    if (user['authToken'] && user['userType'] !== 'R') {
      checkTokenValid();
    } else {
      redirectToSSO();
    }
  }, [user]);

  const getUserInfo = async () => {

    const cookieName = appData.isBusinessBanner ? 'ACI_S_B_ECommRedirectURL' : 'ACI_S_ECommRedirectURL';
    //clear any existing cookies
    deleteCookie(cookieName);
    await axios
      .get(`${appData.environmentVariables.AUTH_API}&rand=${uuidv4()}`, {
        withCredentials: true,
      })
      .then((response) => {
        if (response.data && response.data['SWY_SHOP_TOKEN']) {
          setUser({
            ...response.data,
            authToken: response.data['SWY_SHOP_TOKEN'],
          });
        } else {
          setUser({ ...response.data });
          setIsUserAuthenticated(false);
          setIsLoading(false);
        }
      })
      .catch((e) => {
        setIsLoading(false);
        setIsUserAuthenticated(false);
      });
  };

  /*    const getUserInfoMobile = () => {
        const dummyUserData = { "shopZipcode": "83713", "preference": "J4U", "banner": "albertsons", "j4uZipcode": "83713", "shopStoreId": "177", "clubCardNumber": "49192897041", "j4uStoreId": "177", "firstName": "nandita", "expireTime": "1600968335000", "displayableBanner": "Albertsons", "SWY_SHOP_TOKEN": "eyJraWQiOiJHT1RLUXY2NG40N3ZRVjVuaGNGSVVveVNtaWhtQTM5V0N4TFNxVXY4WFVrIiwiYWxnIjoiUlMyNTYifQ.eyJ2ZXIiOjEsImp0aSI6IkFULlNIdEVHRUhHNF9ON2tFcGNPVDdtODc5Y0FWMDJmMm43a29mZnBDQ1N2T2cuTjkwUDk0TDhtMXNQTjZpUXNVUnhzQTJnYXlnOWhRcXVlQWxna3pBMmQybz0iLCJpc3MiOiJodHRwczovL2Ficy1xYTEub2t0YXByZXZpZXcuY29tL29hdXRoMi9hdXNkdnV5Y3VsUklZaXRYZzBoNyIsImF1ZCI6IkFsYmVydHNvbnMiLCJpYXQiOjE2MDA5Njc0MzUsImV4cCI6MTYwMDk2ODMzNSwiY2lkIjoiMG9hZHZpNm52c1EzejloS2gwaDciLCJ1aWQiOiIwMHVvNWJzenB1SlJJNE5hTDBoNyIsInNjcCI6WyJvcGVuaWQiLCJwcm9maWxlIiwidXNlZF9jcmVkZW50aWFscyIsIm9mZmxpbmVfYWNjZXNzIiwiZW1haWwiXSwiemlwIjoiODM3MTMiLCJzdWIiOiJuYW5kaXRhLmtvdGhhQGFsYmVydHNvbnMuY29tIiwiaGlkIjoiOTk5MDAyOTMwNjkyIiwiZG5tIjoibmFuZGl0YSIsImFsbiI6IjQ5MTkyODk3MDQxIiwiZ2lkIjoiNTU1LTA4My0xNTcyMzc4NDIyODk0IiwiZWNjIjoiIiwiZm5tIjoibmFuZGl0YSIsImxubSI6ImtvdGhhIiwidXVpZCI6ImVlMTcxMjA3LWQwZDMtNDFhNy1iNTk0LWNmNzAyYWUzYWI5NSIsImpwciI6IiIsImJhbiI6ImFsYmVydHNvbnMiLCJzdHIiOiIxNzciLCJwaG4iOiI0MDg3MDc1NDQ1IiwiYmlkIjoiIn0.YFnjNzpNe3E_pcAc5LsXAbS9u-ybQGknum3iOR9BViIUDeLhfgf9GW7gEohuvb0gAo28AEjjmFNVbsYk1Akoi92h-fumJMWdmrMK6c3yZmKMEQWMnBgwwXV7OXl9kuvCTr5RBr5pjJsGkGYW3s2vaFiGgVGNHFewrVnoy2NdFURg0nGTgzO8X0O4umxnL-QNCH-sFM9ow9ESfduR1VdIIM-vD0_RfiKI2VrPGezSCNiUjYw-lrrcXGdTKg4Ygl5g8LhpDDsp7XJJ7iDroksVIo9On_yqs2ChmI7Nk0LXNMnzsYJyWQEV-WdxWHqdA3t4NsGGODd0AXaUcjbvxlLCQA", "customerId": "555-083-1572378422894", "preferredBanner": "albertsons", "userType": "C" };
        setUser({ ...dummyUserData, authToken: dummyUserData['SWY_SHOP_TOKEN'] });
    }*/

  const checkTokenValid = () => {
    const currentDate = new Date();
    let expiryDate = new Date();
    if (user) {
      expiryDate = new Date(Number(user['expireTime']));
    }
    if (user && user['SWY_SHOP_TOKEN'] && expiryDate > currentDate) {
      console.log(new Date().toISOString(), 'Desktop: User authenticated', get(user, 'UUID'));
      setIsUserAuthenticated(true);
    } else {
      setIsUserAuthenticated(false);
    }
    setIsLoading(false);
  };

  const checkUserHasActiveSession = () => {
    let bTokenValid = false;
    if (appData.platform === 'web') {
      if (appData.environmentVariables.CHECK_USER_ACTIVE_SESSION === true) {
        if (_window()['AB'] && _window()['AB']['COMMON'] && _window()['AB']['COMMON'].getActiveSessionUser) {
          const userFromActiveSession = _window()['AB']['COMMON'].getActiveSessionUser();
          const customerId = userFromActiveSession?.customerId;
          if (customerId === user?.['customerId']) {
            bTokenValid = true;
            return bTokenValid;
          } else {
            // redirectToSSO();
          }
        }
        // redirectToSSO();
      } else {
        //comes here for web if check active session has been set to false.
        bTokenValid = true;
        return bTokenValid;
      }
    } else {
      // For mobile - any logic needed can be added here. for now returning true always
      bTokenValid = true;
      return bTokenValid;
    }
  };

  const doStepUpAuthentication = () => {

    if (appData.environmentVariables.CHECK_STEP_UP_AUTHENTICATION === true) {
      const cookieName = appData.isBusinessBanner ? 'ACI_S_B_ECommRedirectURL' : 'ACI_S_ECommRedirectURL';
      setCookie(cookieName, encodeURIComponent(window.location.href));
      window.location.assign(appData.environmentVariables.SSO_URL);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isLoading,
        isUserAuthenticated,
        checkUserHasActiveSession,
        doStepUpAuthentication,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => {
  const authContext = useContext(AuthContext) as AemAppData;
  return authContext;
};

export { useAuth };
export default AuthProvider;
